export const httpStatus = {
  OK: { key: 200, value: 'OK' },
  UNAUTHORIZED: { key: 401, value: 'Unauthorized' },
  FORBIDDEN: { key: 403, value: 'Forbidden' },
  INTERNAL_SERVER_ERROR: { key: 500, value: 'Internal Server Error' }
}
